module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.site_view == 2) ? _c('div', [_c('component-desktop')], 1) : _c('div', {
    staticClass: "main-wrap"
  }, [_c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container-x"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin": "0em"
    }
  }, [_c('component-items')], 1)])]), _vm._v(" "), _c('component-footer')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03e60b0d"}!./src/pages/ManageOrders/template.html
// module id = 527
// module chunks = 0